import { HasDynamicData } from './has-dynamic-data.model';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { System } from '../System';

@Injectable()
export class DynamicDataInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            map(event => {
                if (event instanceof HttpResponse && event.body) {
                    return new HttpResponse({
                        body: this.processDynamicProperties(event.body),
                        headers: event.headers,
                        status: event.status,
                        statusText: event.statusText,
                        url: event.url
                    });
                } else {
                    return event;
                }
            })
        );
    }

    processDynamicProperties(data: Object) {
        try {
            const keys = Object.keys(data);
            keys.forEach(key => {
                if (data[key] && typeof data[key] == 'object') {
                    data[key] = this.processDynamicProperties(data[key]);
                }
            });
            if (keys.includes('DynamicProperties')) {
                const dynamicObject: HasDynamicData = System.convert(data, new HasDynamicData());
                dynamicObject.createAccessorsAndMutators();
                return dynamicObject;
            } else {
                return data;
            }
        }
        catch {
            return data;
        }
    }
}